var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.56073 3.26181C9.74987 2.91271 10.2509 2.91273 10.44 3.26186L16.9405 15.2628C17.121 15.5959 16.8798 16.0009 16.5009 16.0009H3.4982C3.11929 16.0009 2.87808 15.5959 3.05858 15.2627L9.56073 3.26181ZM11.3193 2.78557C10.752 1.73821 9.24892 1.73813 8.68149 2.78544L2.17934 14.7864C1.63783 15.7858 2.36147 17.0009 3.4982 17.0009H16.5009C17.6375 17.0009 18.3612 15.786 17.8198 14.7865L11.3193 2.78557ZM10.4987 7.50023C10.4987 7.22409 10.2749 7.00023 9.99874 7.00023C9.7226 7.00023 9.49874 7.22409 9.49874 7.50023L9.49874 11.5002C9.49874 11.7764 9.7226 12.0002 9.99874 12.0002C10.2749 12.0002 10.4987 11.7764 10.4987 11.5002L10.4987 7.50023ZM10.7487 13.7502C10.7487 14.1644 10.413 14.5002 9.99874 14.5002C9.58453 14.5002 9.24874 14.1644 9.24874 13.7502C9.24874 13.336 9.58453 13.0002 9.99874 13.0002C10.413 13.0002 10.7487 13.336 10.7487 13.7502Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.eb9ba7b7a6a0d699da369848eb84346f.svg";
export { ForwardRef as ReactComponent };